// src/utils/publicationCalculator.js

// Единая функция для расчета ожидаемых дней публикации
export const calculateExpectedPublicationDays = (month, year, considerCurrentDate = false, excludedDates = []) => {
  const firstDay = new Date(year, month - 1, 1);
  let lastDay;
  
  if (considerCurrentDate) {
    const now = new Date();
    const selectedMonth = new Date(year, month - 1, 1);
    const isCurrentMonth = now.getMonth() === selectedMonth.getMonth() && now.getFullYear() === selectedMonth.getFullYear();
    
    if (isCurrentMonth) {
      lastDay = new Date(now);
    } else {
      lastDay = new Date(year, month, 0);
    }
  } else {
    lastDay = new Date(year, month, 0);
  }
  
  let workingDays = 0;
  let currentDate = new Date(firstDay);
  
  while (currentDate <= lastDay) {
    const dayOfWeek = currentDate.getDay();
    
    // Форматируем текущую дату в строку YYYY-MM-DD с учетом локального времени
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    const currentDateStr = `${year}-${month}-${day}`;
    
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
    const isExcluded = excludedDates.includes(currentDateStr);
    
    if (!isWeekend && !isExcluded) {
      workingDays++;
    }
    currentDate.setDate(currentDate.getDate() + 1);
  }
  
  return workingDays;
};

// Единая функция для расчета проблем публикации
export const calculatePublicationProblems = (data, month, year) => {
  const publicationBySchool = {};
  data.publication.forEach(item => {
    if (!publicationBySchool[item.Код]) {
      publicationBySchool[item.Код] = new Set();
    }
    publicationBySchool[item.Код].add(item.Дата);
  });

  // Добавляем даты для исключения (праздничные дни)
  const excludedDates = [
    '2025-11-03',
    '2025-11-04', 
    '2025-11-05',
    '2026-01-01',
    '2026-01-02',
    '2026-01-03',
    '2026-01-04',
    '2026-01-05',
    '2026-01-06',
    '2026-01-07',
    '2026-01-08',
    '2026-01-09',
    '2026-03-30',
    '2026-03-31',
    '2026-04-01',
    '2026-04-02',
    '2026-04-03',
    '2026-04-04',
    '2026-04-04',
    '2026-04-05'
  ];
  const expectedPublicationDays = calculateExpectedPublicationDays(month, year, true, excludedDates);
  const goodThreshold = Math.max(1, Math.floor(expectedPublicationDays * 0.8));

  const schoolsWithPublicationIssues = data.dates.filter(school => {
    const publicationDays = publicationBySchool[school.Код] ? publicationBySchool[school.Код].size : 0;
    return publicationDays < goodThreshold;
  });

  return schoolsWithPublicationIssues;
};

// Функция для проверки проблем публикации конкретной школы
export const hasPublicationProblems = (school, data, month, year) => {
  const publicationProblems = calculatePublicationProblems(data, month, year);
  return publicationProblems.some(s => s.Код === school.Код);
};

// НОВЫЕ ФУНКЦИИ ДЛЯ СВОЕВРЕМЕННОСТИ

// Получить процент своевременности для школы
export const getSchoolTimeliness = (school, timelinessData) => {
  if (!timelinessData || timelinessData.length === 0) return null;
  const timelinessRecord = timelinessData.find(item => item.Пищеблок === school.Наименование);
  return timelinessRecord ? timelinessRecord.ПроцентСвоевременности : null;
};

// Проверить, есть ли проблема со своевременностью (порог по умолчанию 100%)
export const hasTimelinessProblems = (school, timelinessData, threshold = 100) => {
  const percentage = getSchoolTimeliness(school, timelinessData);
  // Если данных нет, считаем это проблемой
  if (percentage === null) return true;
  return percentage < threshold;
};

// Получить статус своевременности для отображения
export const getTimelinessStatus = (school, timelinessData, threshold = 100) => {
  const percentage = getSchoolTimeliness(school, timelinessData);
  
  if (percentage === null) {
    return { status: 'error', text: 'Нет данных', symbol: '❌' };
  }
  
  if (percentage >= threshold) {
    return { status: 'success', text: `Высокая (${percentage}%)`, symbol: '✓' };
  } else {
    return { status: 'error', text: `Низкая (${percentage}%)`, symbol: '❌' };
  }
};